import axios from "axios";
import * as qs from "qs";

class CBOClient {
    constructor(baseEndpoint) {
        this._abortController = new AbortController();
        this._client = axios.create({
            baseURL: `${location.protocol}//${location.host}` + (baseEndpoint || ''),
            headers: {
                /*"Content-Type": "application/json",*/
                "Accept": "application/json",
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            responseType: "json",
            signal: this._abortController.signal,
        });

        this._client.interceptors.response.use(
            function(response) {
                return response;
            },
            function(error){
                let { response } = error;

                if(response && (response.status === 401)){
                    window.location.reload();
                }
                return Promise.reject(error);
            }
        );
    }

    /**
     *
     * @param {string} url
     * @param {object} params
     * @returns {Promise<AxiosResponse<any>>}
     */
    get(url, params = {}) {
        params = Object.clean(params, true);
        if (params) {
            let paramKeys = Object.keys(params);
            if (paramKeys.length > 0) {
                url += "?" + qs.stringify(params);
            }
        }


        return this._client.get(url);
    }

    /**
     *
     * @param {string} url
     * @param {object} data
     * @returns {Promise<AxiosResponse<any>>}
     */
    post(url, data = {}) {
        return this._client.post(url, Object.clean(data, true));
    }

    /**
     *
     * @param {string} url
     * @param {object} data
     * @returns {Promise<AxiosResponse<any>>}
     */
    put(url, data = {}) {
        return this._client.put(url, Object.clean(data));
    }

    /**
     *
     * @param {string} url
     * @param {object} data
     * @returns {Promise<AxiosResponse<any>>}
     */
    delete(url, data = {}) {
        return this._client.delete(url, Object.clean(data));
    }

    /**
     * Abort all pending requests
     */
    cancel() {
        this._abortController.abort();
    }
}

export default CBOClient;
